import {Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

import {zIndexes} from '../../../constants/index';

export const StyledBasketFooterWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 0, 2, 0),
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[4],
  position: 'relative',
  zIndex: zIndexes.zIndexTen
}));

export const StyleFooterContentWrapper = styled(Box)<{isReactNativeView?: boolean}>(({isReactNativeView, theme}) => ({
  // width: '100%',
  padding: isReactNativeView ? theme.spacing(1, 2, 1, 2) : theme.spacing(2, 4, 0, 4),
  gap: isReactNativeView ? '8px' : '0px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& > div': {
    flex: 1
  }
}));

export const StyledBox = styled(Box)(({theme}) => ({
  background: theme.palette.common.mds_global_color_red_15
}));

export const DeliveryFeesLabel = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.caption.fontWeight,
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.grey[900],
  lineHeight: theme.typography.caption.lineHeight
}));

export const BasketTotalPrice = styled(Typography)<TypographyProps>(({theme}) => ({
  fontWeight: theme.typography.h2.fontWeight,
  fontSize: theme.typography.h5.fontSize,
  color: theme.palette.primary.main,
  lineHeight: theme.spacing(0.25)
}));
